export default {
  ORGANIZATIONS_LIST: "Liste des organisations",
  ADD_ORGANIZATION: "Ajouter une organisation",
  ORGANIZATION_ADDED: "Organisation ajoutée",
  OWNER: "Propriétaire",
  EDIT_ORGANIZATION: "Modifier une organisation",
  ORGANIZATION_UPDATED: "Organisation mise à jour",
  SELECT_A_PACKAGE: "Choisir un forfait",
  ADD_SUBSCRIPTION: "Ajouter un abonnement",
  SUBSCRIPTION_INVOICE_ADDED: "Facture abonnement ajoutée",
  AUTHORIZATIONS: "Autorisations",
  DELETE_THIS_ORGANIZATION: "Supprimer cette organisation ?",
  ORGANIZATION_DELETED: "Organisation supprimée",
  VIEW_ORGANIZATION: "Organisation",
  VALIDATE: "Valider",
  CERTIFIED_LETTER_CONTENT: "Contenu de la lettre certifiée",
  WEBSITE_CONTENT: "Contenu du site web",
  PUBLIC_NOTICE_CONTENT: "Contenu de l'avis public",
  ONESPAN_ACCOUNT: "Compte OneSpan",
  ACCOUNTS: "Comptes",
  VIEW_ELIXIO_SYNC: "Modules Elixio Connect",
  VIEW_ELIXIO_SHIPPING: "Expéditions",
  VIEW_ELIXIO_SIGNATURE_TEMPLATES: "Modèles de signature",
  ADD_ELIXIO_SYNC_SERVICE: "Ajouter un service",
  ADD_ELIXIO_SYNC_CONFIGURE_THIS_SERVICE: "Configurer",
  ELIXIO_SYNC_SUBMIT: "Soumettre",
  ELIXIO_SYNC_TEST_CONFIG: "Configurations Test",
  ELIXIO_SYNC_PROD_CONFIG: "Configurations Prod",
  ELIXIO_SYNC_CONFIRM_THIS_SUBSCRIPTION: "Confirmer cette action?",
  ELIXIO_ADDITIONNAL_CONFIG_TITLE: "Configuration additionnelle",
  ELIXIO_START_SYNC: "Lancer",
  ELIXIO_PENDING_SYNC: "Mise à jour en cours ...",
  ELIXIO_STOP_SYNC: "Arreter",
  ELIXIO_TAB_DATA_TITLE: "Synchroniser les données existantes",
  ELIXIO_TAB_CONFIG: "Configuration",
  ELIXIO_TAB_UPDATE_DATA: "Synchroniser les données existantes",
  ELIXIO_SYNC_STATUS_PENDING: "En cours",
  ELIXIO_SYNC_STATUS_DONE: "Terminé",
  ELIXIO_UPDATED_INVOICES: "Synchonisation des factures",
  ELIXIO_UPDATED_PAYMENTS: "Synchonisation des paiements",
  ELIXIO_UPDATED_CUSTOMERS: "Synchonisation des clients",
  ELIXIO_SYNC_COMPLETED: "Synchronisation terminée",
  ELIXIO_SYNC_CANCELLED: "Synchronisation annulée",
  ELIXIO_SYNC_TOTAL_PROGRESS: "Progression totale",
  ELIXIO_START_IMPORT_AT: "Démarrer à partir de:",
  SELECT_DATE: "Sélectionner une date",
};
